var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-pagination',{key:_vm.totalRows,staticClass:"mb-0",attrs:{"align":"right","per-page":_vm.limit,"total-rows":_vm.totalRows,"value":_vm.value,"disabled":_vm.disabled},on:{"change":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }